import { render, staticRenderFns } from "./product-include-view.vue?vue&type=template&id=a46ccea4&"
import script from "./product-include-view.vue?vue&type=script&lang=js&"
export * from "./product-include-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports